export const migrateToV3 = (entities)=>{
    return entities;
};

//# sourceMappingURL=v3.js.map